import * as React from 'react';
import * as TogglePrimitive from '@radix-ui/react-toggle';
import { joinClassnames } from '../../utils';

// Reusable toggle component (see https://ui.shadcn.com/docs/components/toggle for more info)
const Toggle = React.forwardRef<
  React.ElementRef<typeof TogglePrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof TogglePrimitive.Root>
>(({ className, ...props }, ref) => (
  <TogglePrimitive.Root
    ref={ref}
    className={joinClassnames(
      'flex flex-col items-center justify-center h-10 bg-[#000000] text-[8px] leading-[8px] text-white font-medium ring-offset-background transition-colors hover:bg-opacity-70 hover:text-opacity-70 disabled:cursor-not-allowed focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 data-[state=on]:text-white',
      className ?? ''
    )}
    {...props}
  />
));

Toggle.displayName = TogglePrimitive.Root.displayName;

export { Toggle };
